import { z } from 'zod'

export const COACHING_YPO_IMPORT_CONTRACT_VERSION = '1.0.0' as const
export const coachingYpoImportResponseSchema = z.unknown()
export type CoachingYpoImportResponse = z.infer<typeof coachingYpoImportResponseSchema>
